import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

import ArchivedPrintBulletinAnnuel from './ArchivedPrintBulletinAnnuel';
import ArchiveduseYear from './ArchiveduseYear';
import OldStudentProfileLayout from '../view-archived-student/OldStudentProfileLayout';
import EleveService from '../../services/EleveService';
import SalledeclasseService from '../../services/SalledeclasseService';

const ArchivedDetailsBulletinAnnuel = () => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});

	const { yearOptions, selectedYear, handleYearChange } = ArchiveduseYear();
	const { id } = useParams();
	const [salledeclasse, setSalledeclasse] = useState([]);
	const [classeEleve, setClasseEleve] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchEleveData = async () => {
			try {
				const eleveData = await EleveService.getEleve(id);
				setClasseEleve(eleveData.data.salledeclasse);
			} catch (error) {
				console.error('Error fetching student data', error);
			} finally {
				setLoading(false);
			}
		};

		const fetchClassOptions = async () => {
			try {
				const classes = await SalledeclasseService.getClassOptions();
				setSalledeclasse(classes);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchClassOptions();
		fetchEleveData();
	}, [id]);

	if (loading) {
		return (
			<OldStudentProfileLayout>
				<Spinner animation="border" variant="primary" />
			</OldStudentProfileLayout>
		);
	}

	if (!classeEleve || !salledeclasse.length) {
		return (
			<OldStudentProfileLayout>
				<p>Erreur : Données non trouvées.</p>
			</OldStudentProfileLayout>
		);
	}

	return (
		<OldStudentProfileLayout>
			<Card className="w-100">
				<Row className="align-items-center pt-3 mb-6 px-3">
					<Col>
						<Form.Group as={Row} className="mb-3">
							<Col sm={6}>
								<Form.Label htmlFor="anneescolaire">Année Scolaire</Form.Label>
								<Form.Select
									id="anneescolaire"
									name="anneescolaire"
									size="sm"
									value={selectedYear.id || ''}
									onChange={(e) =>
										handleYearChange(parseInt(e.target.value, 10))
									}
								>
									{yearOptions.map((option, index) => (
										<option key={index} value={option.value}>
											{option.label}
										</option>
									))}
								</Form.Select>
							</Col>

							<Col sm={6}>
								<Form.Label htmlFor="salledeclasse">Salle de classe</Form.Label>
								<Form.Select
									id="salledeclasse"
									name="salledeclasse"
									size="sm"
									value={classeEleve || ''}
									onChange={(e) => setClasseEleve(e.target.value)}
								>
									{salledeclasse.map((choice, index) => (
										<option key={index} value={choice.value}>
											{choice.label}
										</option>
									))}
								</Form.Select>
							</Col>
						</Form.Group>
					</Col>

					<Col className="text-end mb-3">
						<Link
							to="#"
							className="text-muted print-link no-print text-end"
							onClick={handlePrint}
						>
							<i className="fa-solid fa-print"></i>
						</Link>
					</Col>
				</Row>
				<ArchivedPrintBulletinAnnuel
					ref={componentRef}
					selectedYear={selectedYear}
					eleveId={Number(id)}
					salledeclasseId={classeEleve}
				/>
			</Card>
		</OldStudentProfileLayout>
	);
};

export default ArchivedDetailsBulletinAnnuel;
